import { render, staticRenderFns } from "./WhatsappEvents.vue?vue&type=template&id=61abec81"
import script from "./WhatsappEvents.vue?vue&type=script&lang=js"
export * from "./WhatsappEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports